import { FileTextOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import {
  AssignableType,
  BasketballClubGame,
  BasketballGame,
  TaskableType,
  TaskEvent,
  TaskEventType,
  UserRole,
} from '@hefe/models';
import { currentUserSelector } from '@hefe/store';
import { formatTime } from '@hefe/utils';
import { Button, Col, Descriptions, Modal, Row, Space, Typography } from 'antd';
import { useMemo, useState } from 'react';
import { FaUser, FaUsers } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import TaskAssignmentSelectComponent from '../../../../tasks/components/task-assignment-select/task-assignment-select.component';
import EventReportComponent from '../../event-report/event-report.component';
import NewEventReportButtonComponent from '../../new-event-report-button/new-event-report-button.component';

interface GameDetailsClubComponentProps {
  game: BasketballGame;
  clubDetails?: BasketballClubGame | null;
}
export default function GameDetailsClubComponent(
  props: GameDetailsClubComponentProps
) {
  const { game, clubDetails } = props;

  const user = useSelector(currentUserSelector);

  const [selectedEventReport, setSelectedEventReport] = useState<
    number | undefined
  >(undefined);

  const tasks = useMemo(() => {
    if (!clubDetails?.tasks) return null;

    return (
      clubDetails.tasks
        /*.filter(
        (task) =>
          (clubDetails?.is_home_flag
            ? task.at_home_games
            : task.at_away_games) &&
          (task.is_public || user?.role?.includes(UserRole.BB_ADMIN))
      )*/
        .map((task) => {
          const event = {
            assignments: task?.assignments ?? [],
            id: `0_${clubDetails.game_id}`,
            type: TaskEventType.BASKETBALL_GAME,
          } as TaskEvent;

          const returnValue = [];

          returnValue.push(
            <Space key={`teams_${task.id}`}>
              <FaUsers />
              <TaskAssignmentSelectComponent
                key={`teams_${task.id}`}
                assignments={task?.assignments ?? []}
                event={event}
                type={TaskableType.CLUB}
                taskId={`club_${task.id}`}
                assignableType={AssignableType.BASKETBALL_TEAM}
                disabled={!user?.role?.includes(UserRole.BB_ADMIN)}
                task={task}
              />
            </Space>
          );

          returnValue.push(
            <Space key={`user_${task.id}`}>
              <FaUser />
              <TaskAssignmentSelectComponent
                assignments={task?.assignments ?? []}
                event={event}
                type={TaskableType.CLUB}
                taskId={`club_${task.id}`}
                assignableType={AssignableType.USER}
                disabled={!task?.allow_interaction}
                task={task}
              />
            </Space>
          );

          return (
            <Descriptions.Item label={task.name} key={task.id}>
              <Space direction="vertical">{returnValue}</Space>
            </Descriptions.Item>
          );
        })
    );
  }, [clubDetails, user]);

  const reports = useMemo(() => {
    if (!clubDetails?.reports) return null;

    return clubDetails.reports.map((report) => (
      <Button
        type="link"
        icon={<FileTextOutlined />}
        key={report.id}
        onClick={() => setSelectedEventReport(report.id)}
      >
        {report.title}
      </Button>
    ));
  }, [clubDetails]);

  return (
    <Row>
      <Col xs={24}>
        <Descriptions column={1} size="small" bordered>
          {tasks}
          <Descriptions.Item label={t('game_reports.plural')}>
            <Space direction="vertical">
              {reports}
              <NewEventReportButtonComponent
                game={game}
                clubDetails={clubDetails}
              />
            </Space>
          </Descriptions.Item>
        </Descriptions>
        {game?.other_games && game?.other_games?.length > 0 && (
          <div style={{ marginTop: 15 }}>
            <Typography.Title level={5}>
              {t('games.other_games.same_day.title')}
            </Typography.Title>
            <Space direction="vertical">
              {game?.other_games?.map((otherGame) => (
                <Typography.Text
                  key={otherGame.id}
                  style={{
                    textDecoration: otherGame?.canceled
                      ? 'line-through'
                      : 'none',
                  }}
                >
                  {formatTime(otherGame.date)} | {otherGame.home} -{' '}
                  {otherGame.guest}
                </Typography.Text>
              ))}
            </Space>
          </div>
        )}
      </Col>
      <Modal
        open={selectedEventReport !== undefined}
        onCancel={() => setSelectedEventReport(undefined)}
        zIndex={10000}
        footer={null}
      >
        <EventReportComponent
          game={game}
          reportId={selectedEventReport}
          onDeleted={() => setSelectedEventReport(undefined)}
        />
      </Modal>
    </Row>
  );
}
